export const NETWORK_ERROR_MESSAGE = 'Connection interrupted, please try again.'
